import { Injectable } from '@angular/core';
import { FluxStandardAction } from 'flux-standard-action';
import { ApiResponseActions } from '../api-response/api-response-actions';
export type Action = FluxStandardAction<any, any>;

@Injectable()
export class StepActions {

  static readonly SET_NEXT_STEP = 'SET_NEXT_STEP';
  static readonly SET_ERROR_STATE = 'SET_ERROR_STATE';
  static readonly IS_MOBILE = 'IS_MOBILE';
  static readonly STORE_VIN = 'STORE_VIN';
  static readonly STORE_GUID = 'STORE_GUID';
  static readonly IS_VEHICLE_ASSOCIATED = 'IS_VEHICLE_ASSOCIATED';
  static readonly STORE_GUID_VALUE = 'STORE_GUID_VALUE';

  static setNext(step: string) {
    return {
      type: StepActions.SET_NEXT_STEP,
      payload: { step }
    };
  }
  static setError(error: string) {
    return {
      type: StepActions.SET_ERROR_STATE,
      payload: { error }
    };
  }
  static setIsMobile(value: boolean) {
    return {
      type: StepActions.IS_MOBILE,
      payload: { isMobile: value }
    };
  }
  static storeGuid(value: boolean) {
    return {
      type: StepActions.STORE_GUID,
      payload: {
        storeGuid: value
      }
    };
  }
  static storeGuidValue(value: string) {
    return {
      type: StepActions.STORE_GUID_VALUE,
      payload: {
        storeGuidValue: value,
        apiAction: StepActions.STORE_GUID_VALUE
      }
    };
  }
  static storeVin(value: boolean) {
    return {
      type: StepActions.STORE_VIN,
      payload: {
        storeVin: value
      }
    };
  }
  static isVehicleAssociated(details) {
    return {
      type: StepActions.IS_VEHICLE_ASSOCIATED,
      payload: {
        vehicleAssociationDetails: {
          isVehicleAssociated: details['isVehicleAssociated'],
          vehicleAssociatedGuid: details['vehicleAssociatedGuid']
        }
      }
    };
  }
}
